<template>
    <div class="single-page">
        <header class="header">
            <CurrentAgency layout="single" />
            <div>
                <img src="@ezio/assets/images/ezio/Logo-EZIO.png" alt="" />
            </div>
            <!-- <div></div> -->

            <div class="right">
                <CurrentUser />
            </div>
        </header>
        <div class="centered">
            <router-view />
        </div>
    </div>
</template>

<script lang="ts" setup>
import CurrentAgency from './components/CurrentAgency.vue'
import CurrentUser from '@/layouts/components/CurrentUser.vue'
</script>
<style lang="scss" scoped>
.single-page-content {
    // display: grid;
    // grid-template-columns: 130px 1fr;
    // grid-template-rows: auto 1fr;

    width: 100%;
}

.header {
    grid-column: 1 / -1;
    position: relative;
    z-index: 3;
    display: flex;

    align-items: center;
    justify-content: space-between;

    padding: 20px 50px;
    background: #fff;
    border-bottom: 1px solid var(--c-color-border-hard);
    img {
        display: block;
        width: 90px;
        // padding: 0px 30px;
        // margin: 5px;
    }
    .right {
        display: inline-flex;
        align-items: center;
    }
    @media screen and (max-width: 930px) {
        padding: 10px 20px;
    }
}
.centered {
    display: flex;
    width: 100vw;
    // height: 100vh;

    justify-content: space-around;
}
</style>
